import { useState } from "react";
import { MailCheck, Send } from "lucide-react";
import { toast } from "sonner";
import { API, formatApiErrorDetail } from "@/lib/api";
import Reveal from "@/components/Reveal";

const NewsletterSection = () => {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await API.post("/newsletter", { email });
      setDone(true);
      setEmail("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="mx-auto max-w-7xl px-5 pb-24 md:px-12" data-testid="newsletter-section">
      <Reveal>
        <div className="relative overflow-hidden rounded-3xl border border-crimson/40 bg-gradient-to-br from-crimson/15 via-ink2 to-ink2 p-10 md:p-14">
          <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-crimson/25 blur-[100px]" />
          <div className="relative grid items-center gap-8 lg:grid-cols-[1.3fr_1fr]">
            <div>
              <p className="eyebrow mb-3">Newsletter rojiblanca</p>
              <h2 className="font-display text-3xl font-extrabold uppercase leading-tight text-white sm:text-4xl">
                La previa de cada partido, <span className="text-crimson">en tu correo</span>
              </h2>
              <p className="mt-3 max-w-lg text-slate-300">
                Análisis antes de cada jornada, crónica nada más pitar el árbitro y contenido
                exclusivo. Cero spam, solo fútbol.
              </p>
            </div>
            <div>
              {done ? (
                <div className="flex flex-col items-center gap-3 text-center" data-testid="newsletter-success">
                  <MailCheck className="h-10 w-10 text-glow" />
                  <p className="font-display text-2xl font-bold uppercase text-white">¡Dentro!</p>
                  <p className="text-sm text-slate-400">
                    Ya eres parte de la grada digital. Nos leemos antes del próximo partido.
                  </p>
                </div>
              ) : (
                <form onSubmit={submit} className="flex flex-col gap-3 sm:flex-row" data-testid="newsletter-form">
                  <input
                    required
                    type="email"
                    data-testid="newsletter-email"
                    placeholder="tu@email.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full rounded-full border border-edge bg-ink px-5 py-3.5 text-sm text-white placeholder:text-slate-500 focus:border-crimson focus:outline-none"
                  />
                  <button
                    type="submit"
                    disabled={busy}
                    data-testid="newsletter-submit"
                    className="flex shrink-0 items-center justify-center gap-2 rounded-full bg-crimson px-7 py-3.5 font-display text-base font-bold uppercase tracking-wider text-white transition-transform hover:scale-105 disabled:opacity-50"
                  >
                    <Send className="h-4 w-4" /> {busy ? "Uniendo..." : "Unirme"}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
};

export default NewsletterSection;
